<button class="avatar" *ngIf="userService.loggedInUser" [matMenuTriggerFor]="menu">
  <div aria-hidden="true" class="hidden-version">{{ version }} - {{ userService.loggedInUser['org_id'] }}</div>
  <img [src]="userService.loggedInUser.picture" alt="profile picture" />
  <div class="user-info">
    <span appLongTextTooltip class="user-name">{{ userService.loggedInUser.name }}</span>
    <span appLongTextTooltip class="account-name">{{ userService.accountName }}</span>
  </div>
  <img src="assets/images/arrows/empty-arrow-down.svg" class="drop-down" alt="expand" />
</button>
<mat-menu #menu="matMenu">
  @if (hasRoles) {
    <button class="button disabled" aria-labelledby="role">
      <img src="assets/images/common/user.svg" alt="role" />
      <span id="role"
        >{{ roleLabel | labelsProvider }} <span class="role-name">{{ displayRole }}</span>
        @if (hasMultipleRoles) {
          <span class="additional-roles-badge" [matTooltip]="additionalRolesTooltip">+{{ additionalRolesCount }}</span>
        }
      </span>
    </button>
  }
  <button class="button" (click)="logout()" aria-label="Logout">
    <img src="assets/images/common/logout.svg" alt="logout" />
    <span>{{ 'menu.logout' | labelsProvider }}</span>
  </button>
</mat-menu>
